<template>
   <div class="wrapper">
      <div>
         <CButton color="info" @click="openSchedule"
            ><b>Create Schedule</b></CButton
         >
         <CRow class="mt-3">
            <CCol sm="12">
               <div class="row">
                  <div class="col-md-12">
                     <div class="card">
                        <div class="card-body">
                           <Datatable
                              :items="items"
                              :listtemplate="listtemplate"
                              :fields="fields"
                              :meta="meta"
                              @per_page="handlePerPage"
                              @pagination="handlePagination"
                              @search="handleSearch"
                              @sort="handleSort"
                              @is_active="handleIsActive"
                              @template_filter="handleTemplateFilter"
                              :btn_show="true"
                              :btn_edit="true"
                              :btn_deactivate="true"
                              :btn_Sreactivate="true"
                              :btn_destroy="false"
                              @show="handleShow"
                              @edit="handleEdit"
                              @deactivate="handleDeactivate"
                              @reactivate="handleReactivate"
                              @destroy="handleDestroy"
                              @publish="handleSetPublish"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </CCol>
         </CRow>
         <alertmodal></alertmodal>
         <publishmodal></publishmodal>
      </div>
      <!-- <pre>{{ $data | json }}</pre> -->

   </div>
</template>

<script>
import Datatable from "@/components/datatables_classschedule.vue";
import axios from "axios";
import publishmodal from "./schedule_publish.vue";
import classschedule from "@/services/class_schedule";
import classtemplate from "@/services/class_template";
import alertmodal from "@/views/alert/modal.vue";
import EventBus from "@/eventBus";
import store from "@/store.js";

const token = localStorage.getItem("token");

export default {
   name: "SectionTables",
   components: { alertmodal, Datatable,publishmodal },
   data() {
      return {
         updateSubmit: false,
         largeModal: false,

         //fungsi yang harus digunakan
         //start
         fields: [
            { key: "template_name", sortable: false },
            { key: "publish_date", sortable: false },
            { key: "class_date", sortable: false },
            { key: "location", sortable: false },
            { key: "status", sortable: false },
            { key: "is_active", sortable: false },
            { key: "action", label: "Action", sortable: false },
         ],
         items: [],
         listtemplate:[],
         meta: [],
         current_page: 1,
         per_page: 10,
         search: "",
         sortBy: "created_at",
         sortByDesc: false,
         is_active: 1,
         template: 0,
         //end
      };
      //end
   },

   created() {
      //this.loadData()
   },
   mounted() {
      this.loadData();

      EventBus.$on("TABLE_UPDATE", (data) => {
         if (data) {
            this.loadData();
         }
      });
   },

   methods: {
      openShow: function(id) {
         this.$router.push({ name: "Schedule Detail", query: { id: id } });
      },

      openModalEdit(id) {
         this.$router.push({ name: "Schedule Form", query: { id: id } });
      },
      openSchedule: function() {
         //SET PERMISSION EACH FEATURE
         let Permission = store.state.user.authenticated.permission;
         if (typeof Permission != "undefined") {
            if (Permission.indexOf("Create/edit section") !== -1) {
               //IF ALLOW
               this.$router.push({ name: "Schedule Form" });
               //END ALLOW
            } else {
               //IF NOT
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: "unautenticated",
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            }
         }
         //SET END
      },
      
    openPublish(id,status) {
         var params = { title: "Publish Schedule", mode: "edit", data: id,status };
         EventBus.$emit("OPEN_SHOW_PUBLISH", params);
      },
      deactivate(id) {
         //SET PERMISSION EACH FEATURE
         let Permission = store.state.user.authenticated.permission;
         if (typeof Permission != "undefined") {
            if (Permission.indexOf("Delete section") !== -1) {
               //IF ALLOW
               if (
                  confirm(
                     "Do you really want to deactivate? Deactivate this section can make all content links that have this section will be deleted!"
                  )
               ) {
                  classschedule
                     .deactivateSchedule(id)
                     .then((res) => {
                        EventBus.$emit("TABLE_UPDATE", true);
                        var params = {
                           title: "Success",
                           mode: "success",
                           data: res.message,
                        };
                        EventBus.$emit("OPEN_MODAL_ALERT", params);
                     })
                     .catch((err) => {
                        var params = {
                           title: "Error",
                           mode: "danger",
                           data: err.response.data.message,
                        };
                        EventBus.$emit("OPEN_MODAL_ALERT", params);
                     });
               }
               //END ALLOW
            } else {
               //IF NOT
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: "unautenticated",
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            }
         }
         //SET END
      },

      reactivate(id) {
         //SET PERMISSION EACH FEATURE
         let Permission = store.state.user.authenticated.permission;
         if (typeof Permission != "undefined") {
            if (Permission.indexOf("Delete section") !== -1) {
               //IF ALLOW
               if (confirm("Do you really want to reactivate?")) {
                  classschedule
                     .reactivateSchedule(id)
                     .then((res) => {
                        EventBus.$emit("TABLE_UPDATE", true);
                        var params = {
                           title: "Success",
                           mode: "success",
                           data: res.message,
                        };
                        EventBus.$emit("OPEN_MODAL_ALERT", params);
                     })
                     .catch((err) => {
                        var params = {
                           title: "Error",
                           mode: "danger",
                           data: err.response.data.message,
                        };
                        EventBus.$emit("OPEN_MODAL_ALERT", params);
                     });
               }
               //END ALLOW
            } else {
               //IF NOT
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: "unautenticated",
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            }
         }
         //SET END
      },

      destroy(id) {
         //SET PERMISSION EACH FEATURE
         let Permission = store.state.user.authenticated.permission;
         if (typeof Permission != "undefined") {
            if (Permission.indexOf("Delete section") !== -1) {
               //IF ALLOW
               if (confirm("Do you really want to delete?")) {
                  classschedule
                     .destroySchedule(id)
                     .then((res) => {
                        EventBus.$emit("TABLE_UPDATE", true);
                        var params = {
                           title: "Success",
                           mode: "success",
                           data: res.message,
                        };
                        EventBus.$emit("OPEN_MODAL_ALERT", params);
                     })
                     .catch((err) => {
                        var params = {
                           title: "Error",
                           mode: "danger",
                           data: err.response.data.message,
                        };
                        EventBus.$emit("OPEN_MODAL_ALERT", params);
                     });
               }
               //END ALLOW
            } else {
               //IF NOT
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: "unautenticated",
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            }
         }
         //SET END
      },

      loadData() {
         let current_page = this.search == "" ? this.current_page : 1;
         var params = {
            page: this.current_page,
            per_page: this.per_page,
            search: this.search,
            sortby: this.sortBy,
            sortbydesc: this.sortByDesc ? "DESC" : "ASC",
            is_active: this.is_active,
            template: this.template,
         };
         classtemplate.getTemplate().then((res) => {
               this.listtemplate = res.data
         });
         classschedule
            .getScheduleDataSource(params)
            .then((res) => {
               let getData = res.data;
               this.items = getData.data;
               //this.is_active = res.is_active
               this.meta = {
                  total: getData.total,
                  current_page: getData.current_page,
                  per_page: getData.per_page,
                  from: getData.from,
                  to: getData.to,
                  is_active: res.is_active,
                  template:this.template,
               };
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },

      handlePerPage(val) {
         this.per_page = val;
         this.loadData();
      },

      handlePagination(val) {
         this.current_page = val;
         this.loadData();
      },

      handleSearch(val) {
         this.search = val;
         this.current_page = 1;
         this.loadData();
      },

      handleSort(val) {
         this.sortBy = val.sortBy;
         this.sortByDesc = val.sortDesc;
         this.loadData();
      },

      handleIsActive(val) {
         this.is_active = val;
         this.loadData();
      },
      handleTemplateFilter(val) {
        this.template = val;
        this.meta.template = val;
        this.loadData() 
      },

      ////HANDLE FUNCTION BUTTON ACTION////
      handleShow(val) {
         this.openShow(val);
      },
      handleEdit(val) {
         this.openModalEdit(val);
      },
      handleDeactivate(val) {
         this.deactivate(val);
      },
      handleReactivate(val) {
         this.reactivate(val);
      },
      handleDestroy(val) {
         this.destroy(val);
      },
      handleSetPublish(val,status) {
         this.openPublish(val,status);
      }, 
      
   },
};
</script>
